import { useEffect, useRef, useState } from "react"

// Manages the cover file input and its live object-URL preview, revoking the
// generated URL when it's replaced or the form unmounts.
const useCoverPreview = (initialUrl) => {
  const [preview, setPreview] = useState(initialUrl || null)
  const [coverName, setCoverName] = useState(null)
  const fileRef = useRef(null)
  const objectUrl = useRef(null)

  useEffect(() => () => objectUrl.current && URL.revokeObjectURL(objectUrl.current), [])

  const onFile = (e) => {
    const file = e.target.files[0]
    if (!file) return
    if (objectUrl.current) URL.revokeObjectURL(objectUrl.current)
    objectUrl.current = URL.createObjectURL(file)
    setPreview(objectUrl.current)
    setCoverName(file.name)
  }

  return { preview, coverName, fileRef, onFile }
}

export default useCoverPreview
